/* Chord vocabularies and labels shared by chord exercises, songs and the live analyzer. */
import type { ChordQuality, ChordRef } from '../../core/dsp';

export const QLABEL: Partial<Record<ChordQuality, string>> = {
  '': 'Majör',
  m: 'Minör',
  '7': "Dominant 7'li",
  maj7: "Majör 7'li",
  m7: "Minör 7'li",
  dim: 'Eksik (dim)',
  aug: 'Artık (aug)',
  sus2: 'Sus2',
  sus4: 'Sus4',
};

export const QFEEL: Partial<Record<ChordQuality, string>> = {
  '': 'aydınlık, sağlam',
  m: 'hüzünlü, içe dönük',
  '7': 'gerilimli, çözülmek ister',
  maj7: 'yumuşak, rüya gibi',
  m7: 'yumuşak, hüzünlü',
  dim: 'sıkışık, gergin',
  aug: 'belirsiz, havada',
  sus2: 'açık, askıda',
  sus4: 'askıda, çözülmek ister',
};

const roots = Array.from({ length: 12 }, (_, r) => r);
/** Every major and minor triad. */
export const MAJMIN: ChordRef[] = roots.flatMap((root) => [
  { root, q: '' as const },
  { root, q: 'm' as const },
]);
/** Major, minor and dominant 7th chords on every root. */
export const MAJMIN7: ChordRef[] = roots.flatMap((root) => [
  { root, q: '' as const },
  { root, q: 'm' as const },
  { root, q: '7' as const },
]);
